export default {
    name: 'SidebarBurger',
    components: {},
    props: {
      isOpen: Boolean,
    },
    methods: {

    }
}
